export default __webpack_public_path__ + "static/media/background.2aeee7b2.jpg";